import styled, { css } from "styled-components";

export const FlexLeftLeft = styled.div`
    display: flex;
    ${p =>
        p.theme.xs(css`
            padding: 8px 0;
        `)}
`;
export const FlexLeftRight = styled(FlexLeftLeft)`
    justify-content: flex-end;
    align-items: center;

    [class*="FormElement"] {
        margin-bottom: 0;
    }
`;

export const ScoreSelector = styled.div`
    width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 18px;
    border-radius: 16px;
    background-color: ${p => p.theme.c.white};
    &.Active {
        background-color: ${p => p.theme.c.info};
    }
    text-align: center;
    margin-left: 12px;
    cursor: pointer;
    position: relative;
`;

export const DeleteScore = styled.div`
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: ${p => p.theme.c.disabled};
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    line-height: 14px;
    top: -4px;
    right: -4px;
`;
